import { render, staticRenderFns } from "./MenuIcon.vue?vue&type=template&id=29b962a4&scoped=true"
import script from "./MenuIcon.vue?vue&type=script&lang=js"
export * from "./MenuIcon.vue?vue&type=script&lang=js"
import style0 from "./MenuIcon.vue?vue&type=style&index=0&id=29b962a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b962a4",
  null
  
)

export default component.exports